const { same } = require('../utils');

exports.computeConnectionStrategyFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'connectionStrategy', null, { skipUndefined: false });
